/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/usagesMappers";
import * as Parameters from "../models/parameters";
/** Class representing a Usages. */
var Usages = /** @class */function () {
  /**
   * Create a Usages.
   * @param {LabServicesClientContext} client Reference to the service client.
   */
  function Usages(client) {
    this.client = client;
  }
  Usages.prototype.listByLocation = function (location, options, callback) {
    return this.client.sendOperationRequest({
      location: location,
      options: options
    }, listByLocationOperationSpec, callback);
  };
  Usages.prototype.listByLocationNext = function (nextPageLink, options, callback) {
    return this.client.sendOperationRequest({
      nextPageLink: nextPageLink,
      options: options
    }, listByLocationNextOperationSpec, callback);
  };
  return Usages;
}();
export { Usages };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var listByLocationOperationSpec = {
  httpMethod: "GET",
  path: "subscriptions/{subscriptionId}/providers/Microsoft.LabServices/locations/{location}/usages",
  urlParameters: [Parameters.subscriptionId, Parameters.location],
  queryParameters: [Parameters.apiVersion, Parameters.filter],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {
      bodyMapper: Mappers.ListUsagesResult
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var listByLocationNextOperationSpec = {
  httpMethod: "GET",
  baseUrl: "https://management.azure.com",
  path: "{nextLink}",
  urlParameters: [Parameters.nextPageLink],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {
      bodyMapper: Mappers.ListUsagesResult
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};